var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOutofofficeunibox = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_10768_102045)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.90625 13.7246L7.5 7.50007M10.625 2.08741C7.92926 0.531023 4.55602 1.21108 2.65375 3.5519C2.46808 3.78038 2.37525 3.89461 2.34824 4.05829C2.32675 4.18852 2.35858 4.3611 2.42512 4.47509C2.50874 4.61836 2.65695 4.70393 2.95337 4.87507L12.0466 10.1251C12.3431 10.2962 12.4913 10.3818 12.6572 10.3826C12.7891 10.3832 12.9545 10.3245 13.0565 10.2407C13.1848 10.1355 13.2373 9.99799 13.3423 9.72296C14.4184 6.90513 13.3207 3.64379 10.625 2.08741ZM10.625 2.08741C9.42927 1.39705 7.06083 3.26074 5.33494 6.25007M10.625 2.08741C11.8207 2.77776 11.391 5.76074 9.66506 8.75007M13.75 13.7501H1.25",
  stroke: "#F79009",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_10768_102045"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOutofofficeunibox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/outofofficeunibox.614e728d8204915b75ca4fbee5cea674.svg";